/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "b964d1e161625501402ade7d731c5c74f4071b6f";
